import { render, staticRenderFns } from "./GiamSatTaiChinhDuLieuBaoCao.vue?vue&type=template&id=d89a7238&scoped=true"
import script from "./GiamSatTaiChinhDuLieuBaoCao.vue?vue&type=script&lang=ts"
export * from "./GiamSatTaiChinhDuLieuBaoCao.vue?vue&type=script&lang=ts"
import style0 from "./GiamSatTaiChinhDuLieuBaoCao.vue?vue&type=style&index=0&id=d89a7238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a7238",
  null
  
)

export default component.exports